<template>
  <div class="action-rules">
    <div class="action-rules-list">
      <div class="action-rule-header">
        <div>项目</div>
        <div>答对</div>
        <div>前进</div>
        <div>#</div>
      </div>
      <div class="action-rule" v-for="(rule, key) in rules" :key="key">
        <el-select filterable v-model="rule.source" multiple placeholder="请选择">
          <el-option
            v-for="item in source"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
        <el-input v-model.number="rule.rights"></el-input>
        <el-input v-model.number="rule.next"></el-input>
        <el-button-group>
          <el-button icon="el-icon-top" @click="moveRule(key, -1)"></el-button>
          <el-button icon="el-icon-bottom" @click="moveRule(key, 1)"></el-button>
          <el-button icon="el-icon-delete" @click="removeRule(key)"></el-button>
        </el-button-group>
      </div>
    </div>
    <div class="text-center" style="margin-top:10px;">
      <el-button type="text" icon="el-icon-plus" @click="addRule">添加动作</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ActionRules',
  props: {
    source: Array,
    value: Array,
    selection: [Array, Number]
  },
  data () {
    return {
      rules: this.value || [],
    }
  },
  watch: {
    value () {
      this.rules = this.value || []
    },
    rules: {
      handler () {
        this.$emit('input', this.rules)
      },
      deep: true
    }
  },
  methods: {
    addRule () {
      let rule = {
        source: [],
        rights: 1,
        next: 2,
      }
      if (this.selection) {
        if (Array.isArray(this.selection)) {
          rule.source = this.selection.slice(0)
        } else {
          rule.source.push(this.selection)
        }
      }
      this.rules.push(rule)
    },
    moveRule(index, offset) {
      let item = this.rules[index]
      if (offset > 0 && index + offset < this.rules.length) {
        this.rules.splice(index + offset + 1, 0, item)
        this.rules.splice(index, 1)
      } else if (offset < 0 && index + offset >= 0) {
        this.rules.splice(index, 1)
        this.rules.splice(index + offset, 0, item)
      }
    },
    removeRule(index) {
      this.rules.splice(index, 1)
    }
  }
}
</script>

<style lang="scss">
.action-rule-header{
  display: grid;
  grid-template-columns: 1fr 40px 40px 36px*3;
  grid-row-gap: 10px;
  grid-column-gap: 8px;
  border-bottom: 1px solid #ebeef5;
  padding-bottom: 10px;
  margin-bottom: 10px;
  > div {
    text-align: center;
    color: #909399;
    &:first-child {
      text-align: left;
    }
  }
}
.action-rule{
  display: grid;
  grid-template-columns: 1fr 40px 40px 36px*3;
  grid-row-gap: 10px;
  grid-column-gap: 8px;
  + .action-rule {
    margin-top: 10px;
  }
  .el-button {
    padding-left: 10px;
    padding-right: 10px;
  }
}
</style>